import { IIconProps } from "@/models";
import { SvgIcon } from "@mui/material";
import { memo } from "react";

const RequiredIcon = ({ sx, ...otherProps }: IIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 7 7"
      sx={{ fontSize: "inherit", fill: "none", ...sx }}
      {...otherProps}
    >
      <path
        d="M3.02273 6.04545L3.10227 3.85795L1.25284 5.03125L0.775568 4.19602L2.72443 3.18182L0.775568 2.16761L1.25284 1.33239L3.10227 2.50568L3.02273 0.318182H3.97727L3.89773 2.50568L5.74716 1.33239L6.22443 2.16761L4.27557 3.18182L6.22443 4.19602L5.74716 5.03125L3.89773 3.85795L3.97727 6.04545H3.02273Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default memo(RequiredIcon);
